import React, { useEffect, useState, memo } from 'react';
import { ArrowRightIcon, ClockIcon, CheckCircleIcon, AlertCircleIcon } from 'lucide-react';
import { trackAddToCart } from './MetaPixel';
const Hero = () => {
  const handleCTAClick = () => {
    // Registrar evento de Add to Cart cuando se hace clic en el CTA principal
    trackAddToCart();
    // Abrir el checkout en la misma página
    window.location.href = 'https://shopysv.com/products/pide-tu-gorro-anti-migrana';
  };
  // Estado para el contador regresivo
  const [timeLeft, setTimeLeft] = useState({
    hours: 2,
    minutes: 59,
    seconds: 59
  });
  // Estado para notificaciones de compra
  const [showNotification, setShowNotification] = useState(false);
  const [notificationData, setNotificationData] = useState({
    name: '',
    location: '',
    time: ''
  });
  // Datos de compradores recientes ficticios
  const recentBuyers = [{
    name: 'María L.',
    location: 'San Salvador',
    time: 'hace 5 minutos'
  }, {
    name: 'Carlos R.',
    location: 'Santa Ana',
    time: 'hace 8 minutos'
  }, {
    name: 'Ana M.',
    location: 'San Miguel',
    time: 'hace 12 minutos'
  }, {
    name: 'Roberto G.',
    location: 'La Libertad',
    time: 'hace 17 minutos'
  }, {
    name: 'Laura P.',
    location: 'Sonsonate',
    time: 'hace 23 minutos'
  }];
  // Efecto para el contador regresivo
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        } else {
          // Reiniciar cuando llegue a 0
          return {
            hours: 2,
            minutes: 59,
            seconds: 59
          };
        }
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  // Efecto para mostrar notificaciones de compra aleatorias (reducido)
  useEffect(() => {
    const showRandomNotification = () => {
      const randomBuyer = recentBuyers[Math.floor(Math.random() * recentBuyers.length)];
      setNotificationData(randomBuyer);
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 4000);
    };
    // Mostrar primera notificación después de 15 segundos (aumentado)
    const firstTimer = setTimeout(showRandomNotification, 15000);
    // Mostrar notificaciones periódicamente cada 45 segundos (reducido)
    const intervalTimer = setInterval(showRandomNotification, 45000);
    return () => {
      clearTimeout(firstTimer);
      clearInterval(intervalTimer);
    };
  }, []);
  return <section className="pt-0 pb-16 md:pt-0 md:pb-24 bg-gradient-to-b from-[#f8f9ff] to-[#eef2ff]" data-id="element-254">
      <div className="container mx-auto px-4 md:px-6" data-id="element-255">
        <div className="flex flex-col md:flex-row items-center" data-id="element-256">
          <div className="md:w-1/2 mb-10 md:mb-0" data-id="element-257">
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-[#1e293b]" data-id="element-258">
              <span className="block" data-id="element-259">15 minutos rutinarios.</span>
              <span className="block" data-id="element-260">Sin pastillas.</span>
              <span className="block" data-id="element-261">Sin efectos secundarios.</span>
            </h1>
            <p className="text-xl md:text-2xl text-[#4a5568] mb-8" data-id="element-262">
              Te han dicho que el dolor es algo con lo que debes aprender a
              vivir. Pero... ¿y si eso no fuera cierto?
            </p>
            {/* Contador regresivo */}
            <div className="bg-white p-4 rounded-lg shadow-md mb-6 border-2 border-[#8b5cf6] animate-pulse" data-id="element-263">
              <p className="text-[#4a5568] font-medium mb-2" data-id="element-264">
                Esta oferta expira en:
              </p>
              <div className="flex justify-center space-x-4" data-id="element-265">
                <div className="flex flex-col items-center" data-id="element-266">
                  <div className="bg-[#8b5cf6] text-white text-xl font-bold rounded-md w-12 h-12 flex items-center justify-center" data-id="element-267">
                    {timeLeft.hours.toString().padStart(2, '0')}
                  </div>
                  <span className="text-xs mt-1" data-id="element-268">Horas</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-269">
                  <div className="bg-[#8b5cf6] text-white text-xl font-bold rounded-md w-12 h-12 flex items-center justify-center" data-id="element-270">
                    {timeLeft.minutes.toString().padStart(2, '0')}
                  </div>
                  <span className="text-xs mt-1" data-id="element-271">Min</span>
                </div>
                <div className="flex flex-col items-center" data-id="element-272">
                  <div className="bg-[#8b5cf6] text-white text-xl font-bold rounded-md w-12 h-12 flex items-center justify-center" data-id="element-273">
                    {timeLeft.seconds.toString().padStart(2, '0')}
                  </div>
                  <span className="text-xs mt-1" data-id="element-274">Seg</span>
                </div>
              </div>
            </div>
            <div className="flex flex-col sm:flex-row gap-4" data-id="element-275">
              <button onClick={handleCTAClick} className="bg-[#8b5cf6] hover:bg-[#7c3aed] text-white px-8 py-4 rounded-full text-lg font-medium transition-all transform hover:scale-105 shadow-lg flex items-center justify-center group" data-id="element-276">
                <span className="group-hover:translate-x-1 transition-transform" data-id="element-277">
                  Quiero alivio ahora
                </span>{' '}
                <ArrowRightIcon size={20} className="ml-2 group-hover:translate-x-1 transition-transform" data-id="element-278" />
              </button>
              <div className="flex items-center text-[#4a5568]" data-id="element-279">
                <ClockIcon size={20} className="mr-2 text-[#8b5cf6]" data-id="element-280" />
                <span data-id="element-281">Envío en 24-48h</span>
              </div>
            </div>
            {/* Indicador de visitantes actuales */}
            <div className="mt-6 flex items-center text-[#4a5568]" data-id="element-282">
              <div className="w-2 h-2 bg-green-500 rounded-full mr-2 animate-pulse" data-id="element-283"></div>
              <p className="text-sm" data-id="element-284">
                <strong className="font-medium" data-id="element-285">28 personas</strong> están
                viendo este producto ahora mismo
              </p>
            </div>
          </div>
          <div className="md:w-1/2 flex justify-center" data-id="element-286">
            <div className="relative" data-id="element-287">
              <div className="absolute -inset-0.5 bg-gradient-to-r from-[#8b5cf6] to-[#4ade80] rounded-2xl blur opacity-30 animate-pulse" data-id="element-288"></div>
              <div className="relative bg-white rounded-2xl shadow-xl overflow-hidden" data-id="element-289">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cxax1UPkZhQUxg6w756oR7/imgi_1_0830_2.gif" alt="Corona de Alivio 360 - Alivia el dolor sin analgésicos" className="w-full h-auto object-cover" width="500" height="500" fetchpriority="high" data-id="element-290" />
                {/* Sello de garantía */}
                <div className="absolute -bottom-5 -right-5 bg-yellow-400 text-black text-xs font-bold p-2 rounded-full w-24 h-24 flex items-center justify-center transform rotate-12 shadow-lg border-2 border-white" data-id="element-291">
                  <div className="text-center" data-id="element-292">
                    <div className="text-sm" data-id="element-293">GARANTÍA</div>
                    <div className="text-lg" data-id="element-294">30 DÍAS</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Notificación de compra reciente */}
      {showNotification && <div className="fixed bottom-4 left-4 bg-white p-3 rounded-lg shadow-lg border-l-4 border-[#4ade80] max-w-xs animate-slideIn z-50 flex items-start" data-id="element-295">
          <CheckCircleIcon className="text-[#4ade80] mr-3 mt-1 shrink-0" size={20} data-id="element-296" />
          <div data-id="element-297">
            <p className="font-medium text-[#1e293b]" data-id="element-298">
              {notificationData.name} de {notificationData.location}
            </p>
            <p className="text-sm text-[#4a5568]" data-id="element-299">
              acaba de comprar una Corona de Alivio 360 {notificationData.time}
            </p>
          </div>
        </div>}
      <style jsx data-id="element-300">{`
        @keyframes slideIn {
          0% {
            transform: translateX(-100%);
            opacity: 0;
          }
          10% {
            transform: translateX(0);
            opacity: 1;
          }
          90% {
            transform: translateX(0);
            opacity: 1;
          }
          100% {
            transform: translateX(-100%);
            opacity: 0;
          }
        }
        .animate-slideIn {
          animation: slideIn 4s ease-in-out;
        }
      `}</style>
    </section>;
};
export default memo(Hero);